import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

const REVIEWS = [
  {
    name: "Marco T.",
    text: "Finalmente un barbiere che si prende il tempo giusto. Un'ora tutta per me, zero fretta: la sfumatura più precisa che abbia mai avuto.",
  },
  {
    name: "Alessandro R.",
    text: "Il rito del panno caldo è un'esperienza vera. Si esce rigenerati. Ambiente curatissimo nel cuore di Atri.",
  },
  {
    name: "Francesco D.",
    text: "Prenotazione online comodissima, Daniele preciso e puntuale. Il taglio tiene la forma per settimane.",
  },
  {
    name: "Giovanni P.",
    text: "La bottega è bellissima e il caffè ottimo. Non è solo un taglio: è un'ora di pausa dal mondo.",
  },
];

export function Reviews() {
  return (
    <section id="recensioni" className="relative py-24 sm:py-36 border-t border-white/[0.06]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6"
        >
          <div>
            <p className="text-xs font-mono tracking-[0.3em] uppercase text-ember">Dicono di noi</p>
            <h2 className="mt-4 font-serif font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-ivory">
              Chi si è seduto su <span className="italic text-ember">quella poltrona.</span>
            </h2>
          </div>
          <div className="flex items-center gap-3">
            <div className="flex text-ember">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={18} fill="currentColor" strokeWidth={0} />
              ))}
            </div>
            <span className="font-serif text-3xl text-ivory">5.0</span>
          </div>
        </motion.div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {REVIEWS.map((r, i) => (
            <motion.figure
              key={r.name}
              data-testid={`review-card-${i}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
              className="bg-card border border-white/[0.08] hover:border-ember/40 rounded-lg p-7 flex flex-col transition-all duration-300 hover:-translate-y-1"
            >
              <Quote size={22} className="text-ember/60" />
              <blockquote className="mt-4 text-sm sm:text-base text-sand leading-relaxed flex-1">
                {r.text}
              </blockquote>
              <figcaption className="mt-6 pt-4 border-t border-white/[0.08] flex items-center justify-between">
                <span className="font-serif text-lg text-ivory">{r.name}</span>
                <div className="flex text-ember">
                  {[...Array(5)].map((_, j) => (
                    <Star key={j} size={12} fill="currentColor" strokeWidth={0} />
                  ))}
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
